import { Link } from "react-router-dom";
import { COLORS } from "../../../../utils/Colors";

interface NavItemProps {
  path?: string;
  icon?: React.ElementType;
  label?: string;
  isActive?: boolean;
  isCollapsed?: boolean;
  isSubItem?: boolean;
  onNavigate?: () => void;
  notifCount?: number;
}

export const NavItem: React.FC<NavItemProps> = ({
  path,
  icon: Icon,
  label,
  isActive,
  isCollapsed,
  isSubItem = false,
  notifCount,
}) => (
  <Link to={path!!}>
    <div className="item-container">
      <li
        className={`sidebar-item ${isActive ? "active" : ""} ${
          isSubItem ? "subitem" : ""
        } ${isCollapsed ? "collapsed-item" : ""}`}
        data-tooltip={isCollapsed ? label : undefined}
      >
        {Icon && (
          <Icon
            size={20}
            color={isActive ? COLORS.Brand.Primary : COLORS.Neutral.Gray}
            className={`sidebar-icon ${isCollapsed ? "collapsed-item-icon" : ""}`}
          />
        )}
        {!isCollapsed && <span>{label}</span>}
      </li>
      {notifCount && notifCount > 0 && (
        <span className="notif-count">{notifCount}</span>
      )}
    </div>
  </Link>
);
